import { render, staticRenderFns } from "./QuestionMulti.vue?vue&type=template&id=394f9318&scoped=true"
import script from "./QuestionMulti.vue?vue&type=script&lang=js"
export * from "./QuestionMulti.vue?vue&type=script&lang=js"
import style0 from "./QuestionMulti.vue?vue&type=style&index=0&id=394f9318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394f9318",
  null
  
)

export default component.exports